export default __webpack_public_path__ + "static/media/louise_teo.b7deb4f1.jpg";